import React from 'react';
import {connect} from 'react-redux';

import Repeater from '@Utils/Repeater';
import {AppState} from '@Redux/store';
import {Troop} from '@Models';
import {TroopProfilView} from "@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View";

interface IUnitV1ProfilProps {
  troops: Array<TroopProfilView>
}

const UnitV1Profil: React.FC<UnitV1ProfilProps> = ({troops}) => {

  return (
    <div className="col-12">
      <table className="content-stats stats-v2 stats-global">
        <thead>
        <tr>
          <th scope="col">Troops</th>
          <th scope="col" className="text-center">M</th>
          <th scope="col" className="text-center">WS</th>
          <th scope="col" className="text-center">BS</th>
          <th scope="col" className="text-center">S</th>
          <th scope="col" className="text-center">T</th>
          <th scope="col" className="text-center">W</th>
          <th scope="col" className="text-center">I</th>
          <th scope="col" className="text-center">A</th>
          <th scope="col" className="text-center">Ld</th>
          <th scope="col" className="text-center">Troop's type</th>
        </tr>
        </thead>
        <tbody>
        <Repeater data={troops} indexPrefix='troop'>
          {
            (item: Troop) =>
              <tr>
                <td>{item.name}</td>
                <td className="text-center">{item.carac.M}</td>
                <td className="text-center">{item.carac.WS}</td>
                <td className="text-center">{item.carac.BS}</td>
                <td className="text-center">{item.carac.S}</td>
                <td className="text-center">{item.carac.T}</td>
                <td className="text-center">{item.carac.W}</td>
                <td className="text-center">{item.carac.I}</td>
                <td className="text-center">{item.carac.A}</td>
                <td className="text-center">{item.carac.LD}</td>
                <td className="text-center">{item.carac.troop_type?.name}</td>
              </tr>
          }
        </Repeater>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IUnitV1ProfilProps) => ({
  troops: owsProps.troops,
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UnitV1Profil);

type UnitV1ProfilProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
